var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBookmarkRemoving = function SvgBookmarkRemoving(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#58b7a1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 14.56-3.308 1.42q-.754.323-1.431-.123-.678-.446-.678-1.253V4.432q0-.63.437-1.069a1.45 1.45 0 0 1 1.07-.437h7.82q.63 0 1.069.437.437.438.437 1.07v10.17q0 .81-.678 1.254-.678.446-1.43.123zm0-1.384 3.806 1.64q.128.054.244-.025a.25.25 0 0 0 .116-.216V4.432a.24.24 0 0 0-.08-.176.25.25 0 0 0-.176-.08H6.09a.25.25 0 0 0-.177.08.25.25 0 0 0-.08.176v10.143q0 .136.116.216a.24.24 0 0 0 .244.024z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c2632",
    strokeLinecap: "round",
    d: "m15.96 15.28.014.023.074.12.013.021.01.022.042.096a1.2 1.2 0 0 1-1.905 1.338l-.019-.016-.016-.018-.097-.103-.019-.019L4.05 3.734a1.2 1.2 0 0 1 1.9-1.464z"
  }))));
};
export default SvgBookmarkRemoving;